var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-info"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 35",
    cx: 39.5,
    cy: 36,
    rx: 15,
    ry: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.9997 6.33301C20.5197 6.33301 6.33301 20.5197 6.33301 37.9997C6.33301 55.4797 20.5197 69.6663 37.9997 69.6663C55.4797 69.6663 69.6663 55.4797 69.6663 37.9997C69.6663 20.5197 55.4797 6.33301 37.9997 6.33301ZM37.9997 53.833C36.258 53.833 34.833 52.408 34.833 50.6663V37.9997C34.833 36.258 36.258 34.833 37.9997 34.833C39.7413 34.833 41.1663 36.258 41.1663 37.9997V50.6663C41.1663 52.408 39.7413 53.833 37.9997 53.833ZM41.1663 28.4997H34.833V22.1663H41.1663V28.4997Z",
    fill: "#B880EF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundInfo);
export default __webpack_public_path__ + "static/media/round-info.e2302119c6873d60e8b7b7c1798255e7.svg";
export { ForwardRef as ReactComponent };